if ( $('.container.posts').length ) {
  function loadMorePosts(offset, current_page, is_category, is_tag) {
    $('.more-posts').addClass('loading');
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      dataType: 'html',
      data: ({ action: 'nextPosts',
              offset: offset,
              current_page: current_page,
              is_category: is_category,
              is_tag: is_tag
            }),
      success: function (data) {
        setTimeout(function () {
          $('.next').replaceWith(data);
          $('.more-posts').removeClass('loading');
        }, 200);
      },
      error: function (data) {
        return false;
      }
    });
  }

  $(function(){
    $('.more-posts').removeClass('loading');
  });
}
